module.exports = function getResource(label, vars = []) {
    let resources = {
        back: 'Back'
    };

    return resources[label];
};
